import { render } from "./AgUserMaintenanceComponent.vue?vue&type=template&id=203da95a&scoped=true&ts=true"
import script from "./AgUserMaintenanceComponent.vue?vue&type=script&lang=ts"
export * from "./AgUserMaintenanceComponent.vue?vue&type=script&lang=ts"

import "./AgUserMaintenanceComponent.vue?vue&type=style&index=0&id=203da95a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203da95a"]])

export default __exports__